/**
 * 법률 페이지 공통 상수
 */

import type { ContactTranslations } from './types';

/** 연락처 정보 번역 */
export const contactTranslations: ContactTranslations = {
  ko: '질문이나 우려사항이 있으시면 hola@olulo.com.mx로 문의해 주세요.',
  es: 'Si tiene alguna pregunta o inquietud, contactenos en hola@olulo.com.mx',
  en: 'If you have any questions or concerns, please contact us at hola@olulo.com.mx',
};
